import { getErrorMessage, getSelectedArrivalSlotIsNotAvailableMessage } from '../../utils';
import {
  REQUEST_AVAILABLE_ARRIVAL_TIME_SLOTS,
  RECEIVE_AVAILABLE_ARRIVAL_TIME_SLOTS,
  SET_AVAILABLE_ARRIVAL_TIME_SLOTS_FAILURE,
  CLEAR_ARRIVAL_TIME_ERROR_MESSAGE,
  SET_SELECTED_ARRIVAL_TIME,
  REQUEST_ADDING_ARRIVAL_TIME_SLOT,
  RECEIVE_ADDING_ARRIVAL_TIME_SLOT,
  SET_ADDING_ARRIVAL_TIME_SLOT_FAILURE,
  REQUEST_REMOVE_ARRIVAL_TIME_SLOT,
  RECEIVE_REMOVE_ARRIVAL_TIME_SLOT,
  SET_REMOVE_ARRIVAL_TIME_SLOT_FAILURE,
  SET_ARRIVAL_PAGE_WAS_BOOKED,
} from '../constants/arrivalTime';

const initialState = {
  isFetching: false,
  wasCalled: false,
  wasBooked: false,
  errorMessage: '',
  arrivalTimeSlots: [],
  selectedArrivalSlotId: 0,
  bookedArrivalSlotId: 0,
};

const arrivalTime = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_AVAILABLE_ARRIVAL_TIME_SLOTS: {
      return { ...state, isFetching: true, errorMessage: '' };
    }
    case RECEIVE_AVAILABLE_ARRIVAL_TIME_SLOTS: {
      const { arrivalTimeSlots = [], bookedSlot, bookedShorexItems, isCalledByAnotherAction = false } = action;
      const bookedId = !bookedSlot ? 0 : bookedSlot.code;
      const newState = {
        isFetching: false,
        errorMessage: '',
        wasCalled: true,
        arrivalTimeSlots,
        bookedArrivalSlotId: bookedId,
        bookedShorexItems,
      };
      if (!isCalledByAnotherAction) {
        return {
          ...state,
          ...newState,
          selectedArrivalSlotId: bookedId,
        };
      }
      return {
        ...state,
        ...newState,
      };
    }
    case SET_AVAILABLE_ARRIVAL_TIME_SLOTS_FAILURE: {
      const { error } = action;
      const errorMessage = getErrorMessage(error);
      return { ...state, isFetching: false, errorMessage, wasCalled: true };
    }
    case CLEAR_ARRIVAL_TIME_ERROR_MESSAGE: {
      return { ...state, errorMessage: '' };
    }
    case SET_SELECTED_ARRIVAL_TIME: {
      const { selectedArrivalSlotId } = action;
      return { ...state, selectedArrivalSlotId };
    }
    case REQUEST_ADDING_ARRIVAL_TIME_SLOT: {
      return { ...state, isFetching: true };
    }
    case RECEIVE_ADDING_ARRIVAL_TIME_SLOT: {
      const { bookedArrivalSlotId } = action;
      return { ...state, isFetching: false, errorMessage: '', wasBooked: true, bookedArrivalSlotId };
    }
    case SET_ADDING_ARRIVAL_TIME_SLOT_FAILURE: {
      const { error } = action;
      const errorMessage = error === 'it_does_not_exist_anymore'
        ? getSelectedArrivalSlotIsNotAvailableMessage()
        : getErrorMessage(error);
      return { ...state, isFetching: false, errorMessage };
    }
    case REQUEST_REMOVE_ARRIVAL_TIME_SLOT: {
      return { ...state, isFetching: true };
    }
    case RECEIVE_REMOVE_ARRIVAL_TIME_SLOT: {
      return { ...state, isFetching: false, errorMessage: '', selectedArrivalSlotId: 0, bookedArrivalSlotId: 0 };
    }
    case SET_REMOVE_ARRIVAL_TIME_SLOT_FAILURE: {
      const { error } = action;
      const errorMessage = error === 'it_does_not_exist_anymore'
        ? getSelectedArrivalSlotIsNotAvailableMessage()
        : getErrorMessage(error);
      return { ...state, isFetching: false, errorMessage };
    }
    case SET_ARRIVAL_PAGE_WAS_BOOKED: {
      const { wasBooked } = action;
      return { ...state, wasBooked };
    }
    default:
      return state;
  }
};

export default arrivalTime;
